export const INPUTS_TYPES_WITH_NATIVE_PLACEHOLDER = [
  'date',
  'datetime-local',
  'time',
  'month',
  'week',
];
